"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.faTriangle = void 0;
var faTriangle = {
  prefix: 'fas',
  iconName: 'faTriangle',
  icon: [512, 512, [], '', 'M506.3 417c16.33 28-4.222 63-36.1 63H42.74c-32.89 0-53.33-35.11-36.1-63l213.2-364c16.44-28 57.66-28 73.1 0L506.3 417z']
};
exports.faTriangle = faTriangle;